export default function installMagnificFocusTrapFix() {
  if (window.__ipp_mfp_focus_fix_installed) return;
  window.__ipp_mfp_focus_fix_installed = true;

  const IPP_ID = "inpostpay-widget-popup";
  const MFP_OVERLAY = ".mfp-bg, .mfp-wrap";

  const $ = window.jQuery;
  if (!$) return;

  const mfp = $.magnificPopup;

  let disabled = false;
  let guardInterval = null;
  let originalFocus = null;
  let originalOnFocusIn = null;

  const applyOverlayBlock = () => {
    $(document).off("focusin.mfp");

    document.querySelectorAll(MFP_OVERLAY).forEach((element) => {
      element.style.setProperty("pointer-events", "none", "important");
    });
  };

  const disable = () => {
    if (disabled) return;
    if (!document.getElementById(IPP_ID)) return;

    disabled = true;

    if (!originalFocus) {
      originalFocus = HTMLElement.prototype.focus;

      HTMLElement.prototype.focus = function (...args) {
        if (this.classList && this.classList.contains("mfp-wrap")) {
          return;
        }

        return originalFocus.apply(this, args);
      };
    }

    if (
      !originalOnFocusIn &&
      mfp &&
      mfp.proto &&
      typeof mfp.proto._onFocusIn === "function"
    ) {
      originalOnFocusIn = mfp.proto._onFocusIn;

      mfp.proto._onFocusIn = function (event) {
        const ippPopup = document.getElementById(IPP_ID);

        if (
          ippPopup &&
          (event.target === ippPopup || ippPopup.contains(event.target))
        ) {
          return;
        }

        return originalOnFocusIn.apply(this, arguments);
      };
    }

    applyOverlayBlock();

    if (!guardInterval) {
      guardInterval = window.setInterval(applyOverlayBlock, 200);
    }
  };

  const restore = () => {
    if (!disabled) return;

    disabled = false;

    if (guardInterval) {
      window.clearInterval(guardInterval);
      guardInterval = null;
    }

    if (originalFocus) {
      HTMLElement.prototype.focus = originalFocus;
      originalFocus = null;
    }

    if (originalOnFocusIn && mfp && mfp.proto) {
      mfp.proto._onFocusIn = originalOnFocusIn;
      originalOnFocusIn = null;
    }

    document.querySelectorAll(MFP_OVERLAY).forEach((element) => {
      element.style.removeProperty("pointer-events");
    });
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node && node.nodeType === 1 && node.id === IPP_ID) {
          disable();
        }
      }

      for (const node of mutation.removedNodes) {
        if (node && node.nodeType === 1 && node.id === IPP_ID) {
          restore();
        }
      }
    }
  });

  const startObserver = () => {
    observer.observe(document.body, { childList: true });

    if (document.getElementById(IPP_ID)) {
      disable();
    }
  };

  if (document.body) {
    startObserver();
  } else {
    document.addEventListener("DOMContentLoaded", startObserver, { once: true });
  }
}
